import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';

import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { HisCoreSharedModule } from '../core/his-core-shared.module';
import { HisInputSharedModule } from '../input/his-input-shared.module';
import { HisStructureSharedModule } from '../structure/his-structure-shared.module';
import { ChipModule } from 'primeng/chip';
import { AccordionModule } from 'primeng/accordion';
import { HisSendProblemCaseComponent } from './component/send-problem-case.component';
import { HisProblemCaseFormComponent } from './component/problem-case-form/problem-case-form.component';
import { HisGenericsearchSharedModule } from '../genericsearch/his-genericsearch-shared.module';

/**
 * SharedModule for problem case .
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        AutoCompleteModule,
        CalendarModule,
        InputNumberModule,
        PanelModule,
        TableModule,
        TabsModule,
        DialogModule,
        ConfirmDialogModule,
        HisCoreSharedModule,
        HisStructureSharedModule,
        HisInputSharedModule,
        ChipModule,
        AccordionModule,
        HisGenericsearchSharedModule,
    ],
    declarations: [HisSendProblemCaseComponent, HisProblemCaseFormComponent],
    exports: [HisSendProblemCaseComponent],
})
export class HisProblemCaseSharedModule {}
